import { render } from "./AddPeople.vue?vue&type=template&id=0e8f05e4&ts=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AddPeople.vue?vue&type=script&lang=ts"
export * from "./AddPeople.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__